import { render, staticRenderFns } from "./PrintBulletin.vue?vue&type=template&id=7f312622&"
import script from "./PrintBulletin.vue?vue&type=script&lang=js&"
export * from "./PrintBulletin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports